module.exports = __webpack_public_path__ + "img/云产品顶部.3b9296bd.png";